import { React, useRef, useEffect, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import AlertDialog from '../Modals/AlertDialog'
import ErrorIcon from '@mui/icons-material/Error';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import StyledRadio from '../StyledExtensions/StyledRadio'
import Paper from '@mui/material/Paper';

export default function ContactlessPickup(props) {
    const [contactlessAcknowledged, setContactlessAcknowledged] = useState(props.pickupRequest.isContactless !== undefined ? props.pickupRequest.isContactless : false);
    const [value, setValue] = useState(props.pickupRequest.isContactless !== undefined ? 'Yes' : '');


    const [alertDialog, setAlertDialog] = useState({
        show: false,
        title: '',
        message: '',
        closeButton: '',
    });

    function isValidated() {
        if (contactlessAcknowledged) {
            return true;
        }

        return false;
    }

    function canContinue() {
        if (contactlessAcknowledged && value === "Yes") {
            props.onNext(true);
        }
        else {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <ErrorIcon sx={{ color: 'var(--sipzee-red)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div style={{ marginTop: '10px' }}>We're storry, but at this time, we cannot provide pickup service.</div>
                            <div style={{ marginTop: '10px' }}>We understand that not all apartment buildings and complexes allow leaving bottles &amp; cans in an accessible place.</div>
                            <div style={{ marginTop: '10px' }}>We are working on solutions to provide service to everyone.</div>
                        </div>
                    </div>,
                closeButton: 'Ok',
            });
        }
    }

    function acknowledged(val) {
        setValue(val);
        setContactlessAcknowledged(true);
    }

    return (
        <div style={{maxWidth:'400px', marginLeft:'auto',marginRight:'auto'} }>
            <div className={styles.cardHeader }>Contactless Pickup</div>

            <div style={{ marginTop: '15px' }}>
                Your returner will schedule a pickup time window on or after your available date.
            </div>

            <div style={{ marginTop: '15px' }}>
                You do <b>not</b> need to be present, and should ensure your cans & bottles are <b>outdoors</b> and accessible during the pickup time window.
            </div>

            <div style={{ marginTop: '15px' }}>
                <span style={{ color: 'var(--sipzee-red)', fontWeight: 'bold' }}>THEFT AWARENESS</span> - please be cautious about where you place your cans/bottles to reduce the liklihood of theft.
                We recommend placing them in a location that prevents full visibility from the street - i.e. side of house, behind something, etc.
                <span style={{ color: 'var(--sipzee-red)', fontWeight: 'bold' }}>Sipzee cannot pay you for cans/bottles that we cannot recycle - let's keep those bottles safe!</span>
            </div>

            <div className={styles.cardQuestion} style={{ marginTop: '15px' }}>
                Are you able to leave your cans & bottles in a place outdoors where we can provide a contactless pickup?
            </div>

            <div style={{marginTop:'15px'} }>
                <FormControl>
                    <RadioGroup
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                    >
                        <Paper elevation={5} >
                            <FormControlLabel value="Yes" control={<StyledRadio checked={value === 'Yes'} onChange={(e) => acknowledged(e.target.value)} />} label="Yes - the pickup can be completed without my assistance" />
                        </Paper>
                        <Paper elevation={5} style={{marginTop:'15px' } }>
                            <FormControlLabel value="No" control={<StyledRadio checked={value === 'No'} onChange={(e) => acknowledged(e.target.value)} />} label="No - I need to provide assistance to complete the pickup" />
                        </Paper>
                    </RadioGroup>
                </FormControl>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' ,marginTop:'30px'}} >
                <div style={{ display: 'flex', width:'300px', justifyContent: 'space-between' }}>
                    <Button variant="outlined" onClick={props.onBack} style={{ marginRight: '2px' }}><KeyboardArrowLeft /> Back</Button>
                    <Button variant={isValidated() ? "contained" : "outlined" } color="sipzeeGreen" disabled={!isValidated()} onClick={() => canContinue()}>Next <KeyboardArrowRight /></Button>
                </div>
            </div>
            <AlertDialog isShown={alertDialog.show} close={() => setAlertDialog({ show: false })} Title={alertDialog.title} Message={alertDialog.message} CloseText={alertDialog.closeButton} />
        </div>
    );
}